import type { PostClientResetPassword } from '@lt/api/dist/methods/client/types';
import { api } from 'src/api';
import type { SetRequestStatus } from '../types';
import { RequestStatus } from '../types';
import { useSearchParams } from './useResetPasswordToken';

type Props = {
  setRequestStatus: SetRequestStatus;
  onSuccess: (confirmedEmail: string) => void;
  onFail: () => void;
};

function updateResetPasswordToken() {
  window.history.pushState({}, document.title, window.location.pathname);
}

export const useCreatePassword = ({
  setRequestStatus,
  onSuccess,
  onFail,
}: Props) => {
  const { reset_password_token } = useSearchParams('reset_password_token');

  const handleCreatePassword = async (data: PostClientResetPassword) => {
    try {
      setRequestStatus(RequestStatus.Submitting);
      const response = await api.postClientResetPassword({
        ...data,
        reset_password_token,
      });
      const { success, email } = response;
      if (success) {
        setRequestStatus(RequestStatus.Succeeded);
        updateResetPasswordToken();
        onSuccess(email);
      } else {
        setRequestStatus(RequestStatus.Failed);
        onFail();
      }
    } catch (error) {
      setRequestStatus(RequestStatus.Failed);
      onFail();
      console.error(error);
    }
  };

  return {
    handleCreatePassword,
  };
};
